import React, { useState, useEffect } from "react";
import { object, string, array } from "prop-types";
import { connect } from "react-redux";
import { Link } from "@quintype/components";
import get from "lodash/get";

import Headline from "../../atoms/Headline";
import CardImage from "../../atoms/CardImage";
import { getSlug, getExcerpt, getStoryHeadline } from "../../utils/utils";
import CollectionTitleWithArrow from "../../atoms/CollectionTitleWithArrow";
import StoryMetaData from "../../molecules/StoryMetaData";

import "./fourStoryCards.m.css";

const FourStoryCards = ({ collection, sections, publisherAttributes, domainSlug }) => {
  const [isMobile, setIsMobile] = useState(false);
  const collectionSlug = getSlug(collection, sections, domainSlug);
  const storyList =
    collection.items.length > 0
      ? collection.items.filter(item => item.type === "story" && item.story).slice(0, 4)
      : null;
  const showCollectionName = get(collection, ["associated-metadata", "show_collection_name_website"], null);
  const headlineStyle = publisherAttributes.lang === "en" ? "en-story-headline" : "bn-story-headline";
  const excerptStyle = `${publisherAttributes.lang}-excerpt`;
  const subHeadlineStyle = `${publisherAttributes.lang}-sub-headline`;

  if (!storyList) {
    return null;
  }

  useEffect(() => {
    global.deviceWidth < 876 && setIsMobile(!isMobile);
  }, []);

  return (
    <div styleName="four-story-4s" className="four-story-cards" data-testid="4s-story">
      {showCollectionName && (
        <CollectionTitleWithArrow
          collectionName={collection.name}
          collectionSlug={collectionSlug}
          headlineClassName="collection-name-arrow"
          updatedFont={true}
        />
      )}
      <div styleName="story-container">
        {storyList.map(({ story }, index) => {
          const storyexcerpt = getExcerpt(story);
          const storyHeadline = getStoryHeadline(story);

          return (
            <div styleName="story-card" key={index}>
              <Link href={story.url}>
                <CardImage
                  story={story}
                  defaultWidth={300}
                  aspectRatio={global.deviceWidth < 876 ? [3, 2] : [16, 9]}
                  imageType={global.deviceWidth < 876 ? "image3x2" : "image16x9"}
                  widths={global.deviceWidth < 876 ? [120] : [300]}
                  showAlternateImage={true}
                />
              </Link>

              <div styleName="headline-wrapper">
                {story.subheadline && (
                  <Link href={story.url}>
                    <Headline
                      text={story.subheadline}
                      headerLevel={3}
                      className="section-name"
                      styleName={subHeadlineStyle}
                    />
                  </Link>
                )}
                <Link href={story.url}>
                  <Headline
                    text={storyHeadline}
                    headlineType={21}
                    headerLevel={2}
                    className="story-headline"
                    styleName={headlineStyle}
                  />
                </Link>
                {!isMobile && storyexcerpt && (
                  <Link href={story.url}>
                    <Headline text={storyexcerpt} headerLevel={4} className="sub-headline" styleName={excerptStyle} />
                  </Link>
                )}
              </div>
              <StoryMetaData story={story} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

FourStoryCards.propTypes = {
  accentColor: string,
  collection: object,
  sections: array,
  publisherAttributes: object,
  domainSlug: string
};

const mapStateToProps = state => {
  return {
    sections: get(state, ["qt", "config", "sections"], []),
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
    domainSlug: get(state, ["qt", "config", "domainSlug"], "")
  };
};

export default connect(mapStateToProps)(FourStoryCards);
